import { AxiosInstance, AxiosStatic } from 'axios';
import { InjectionKey } from 'vue';

import { SafeEnv } from 'SharedDir/utils/helpers';

/**
 * Время ожидания перед показом tooltip
 */
export const DELAY_TOOLTIP = 600;

export const CREATE_TYPE = 'create';

/**
 * Периодичность опроса на получение новых сообщений в мс
 */
export const NOTIFICATION_POOLING_TIMEOUT: number = 120000;

/**
 * Периодичность опроса на получение новых черновиков в реестре ТМЦ
 */
export const DRAFT_POOLING_TIMEOUT: number = 120000;

/**
 * Длина пароля
 */
export const PASSWORD_LENGTH = 12;

export const YANDEX_CAPTCHA_SHOW: boolean =
  SafeEnv(() => process.env.YANDEX_CAPTCHA_SHOW) === 'true';

export const NOTIFICATION_WEBPUSH_PUBLIC_VAPID_KEY = SafeEnv(
  () => process.env.NOTIFICATION_WEBPUSH_PUBLIC_VAPID_KEY
);

export const REGION_ENVIRONMENT = SafeEnv(() => process.env.REGION_ENVIRONMENT) ?? 'hmao';

export const COMPARISON_VALUES = [
  {
    title: 'Больше (>)',
    value: '>',
  },
  {
    title: 'Больше или равно (>=)',
    value: '>=',
  },
  {
    title: 'Меньше (<)',
    value: '<',
  },
  {
    title: 'Меньше или равно (<=)',
    value: '<=',
  },
  {
    title: 'Равно (=)',
    value: '=',
  },
  {
    title: 'Не равно (!=)',
    value: '!=',
  },
];

export const AxiosInstanceKey = Symbol('Axios instance key for injection') as InjectionKey<
  AxiosInstance | AxiosStatic
>;
